import * as DASHBOARD_ACTION from 'js/constant/action/dashboard'
import { createAction } from 'redux-actions'
import { getDashboardMetrics } from 'js/redux/api/dashboard'
import { getFile } from 'js/helper/http'

const updateLoader = createAction(DASHBOARD_ACTION.UPDATE_DASHBOARD_LOADER)
const updateTopTenLists = createAction(DASHBOARD_ACTION.UPDATE_TOP10_LISTS)
const updateHighestValues = createAction(DASHBOARD_ACTION.UPDATE_HIGHEST_VALUES)

export const getDashboardData =
    () =>
      async (dispatch, getState, { dashboard }) => {
        try {
          dispatch(updateLoader(true))

          const url = await getDashboardMetrics()
          var data;
          if (typeof url === 'object') {
            data = url;
          } else {
            console.log("Dashboard URL: ", url)
            data = await getFile(url)
          }
          
          console.log("Dashboard data: ", data)
          const highest = Object.keys(data).map(items => (items.length > 0 && { [items]: data[items][0] }))

          await dispatch(updateTopTenLists(data))
          await dispatch(updateHighestValues(highest))
          dispatch(updateLoader(false))
        } catch (error) {
          dispatch(updateLoader(false))
          console.error("Failed to get the dashboard data.", error)
        }
      }
